/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

import { accent, background2 } from '../../../../styles/colors'

export const UpcomingEl = styled.div`
  width: 100%;
  padding: 1em;
  background: #000;
  line-height: 1.5;

  .container {
    background: ${background2};
    padding: 0.75em;
    border-radius: 0.5em;
    text-align: center;

    span {
      font-weight: bold;
      color: ${accent};

      &.artist {
        text-transform: capitalize;
      }

      &.date {
        letter-spacing: 0.025em;
        font-family: monospace;
      }
    }
  }
`
